import { format, parseISO } from 'date-fns'

export function formatDate(value) {
  if (!value) return ''
  if (value === 'infinity') return '∞'
  try {
    const d = value instanceof Date ? value : parseISO(value)
    return format(d, 'dd.MM.yyyy')
  } catch {
    return value
  }
}

export function formatDatetime(value) {
  if (!value) return ''
  try {
    const d = value instanceof Date ? value : parseISO(value)
    return format(d, 'dd.MM.yyyy HH:mm')
  } catch {
    return value
  }
}
